export default "__VITE_ASSET__19592d21__"